<template>
  <!-- 批量票据交接 -->
  <el-dialog title="提示" :visible="visible" @update:visible="(v)=>$emit('update:visible',v)" width="30%">
    <span>确定该项目已完成吗？</span>
    <span slot="footer" class="dialog-footer" v-if="option.btn">
      <el-button v-for="(item,i) in option.btn" :key="i" :type="item.type" @click="onClick(item)">{{item.label}}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { save } from '@/api/cube-agent/supervise/index'
export default {
  props: {
    batch: {
      type: Object,
      default: () => ({
        // 公司id
        ids: [],
        // 所属周期
        cycle: '',
      }),
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      option: {
        btn: [],
      },
    }
  },
  mounted() {
    this.dic()
  },
  methods: {
    dic() {
      this.util.dic('handoverStatus').then(({ data }) => {
        const btnMapTmp = data.map((obj) => ({
          ...obj,
          value: obj.dictKey,
          label: +obj.dictKey === 0 ? '取消' : obj.dictValue,
          type: +obj.dictKey === 0 ? '' : 'primary',
        }))
        this.option.btn = [
          ...btnMapTmp.filter((item) => +item.value !== 0),
          ...btnMapTmp.filter((item) => +item.value === 0),
        ]
      })
    },
    async save({key,value,id}) {
      await save({
        companyDetailId: id,
        cycle: this.batch.cycle,
        [key]:value,
      })
    },
    openFullScreen2(num) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      if (num=='2'){
        loading.close();
      }
    },
    async onClick(currentObj) {
      this.openFullScreen2('1');
      for (let id of this.batch.ids){
        await this.save({id,key:'handoverStatus',value:currentObj.dictKey})
      }
      this.batch.load()
      this.$emit('update:visible',false)
      this.openFullScreen2('2');
    },
  },
}
</script>

<style>
</style>
